import { cn } from '@core/utils';

import { TABS } from '../../../constants';

interface GiftTabContentDeliveryProps {
  deliveryCompanyName: string;
}

export const GiftTabContentDelivery = ({
  deliveryCompanyName,
}: GiftTabContentDeliveryProps) => {
  return (
    <section
      className={cn(
        'flex flex-col gap-64 px-0 pb-120',
        'mobile-tablet:gap-32 mobile-tablet:px-20 mobile-tablet:pb-60',
      )}
      id={TABS.DELIVERY}
    >
      <article className="flex flex-col">
        <h2
          className={cn(
            'pb-16 pt-32 text-[40px] font-600 text-Gray-900',
            'mobile-tablet:pb-8 mobile-tablet:pt-16 mobile-tablet:typo-body1',
          )}
        >
          구매/배송
        </h2>
        <p
          className={cn(
            'mb-32 text-[28px] font-400 text-Gray-600',
            'mobile-tablet:mb-16 mobile-tablet:typo-body4',
          )}
        >
          주문하신 상품은 3일 이내에 출고가 시작될 예정입니다.
          <br />
          물류 상황에 따라 배송이 지연될 수 있음을 양해 부탁드립니다.
        </p>
        <ul
          className={cn(
            'flex flex-col border-t border-Gray-200 text-[28px] font-400 text-Gray-600 [&>li>p]:w-184 [&>li>span]:flex-1 [&>li>span]:font-500 [&>li>span]:text-Gray-700 [&>li]:border-b [&>li]:border-Gray-200 [&>li]:py-18',
            'mobile-tablet:typo-body4 mobile-tablet:[&>li>p]:w-92 mobile-tablet:[&>li]:py-10',
          )}
        >
          <li className="flex items-center gap-16">
            <p>배송방법</p>
            <span>{deliveryCompanyName}</span>
          </li>
          <li className="flex items-center gap-16">
            <p>배송 지역</p>
            <span>전국</span>
          </li>
          <li className="flex items-center gap-16">
            <p>배송비</p>
            <span>무료</span>
          </li>
          <li className="flex items-center gap-16">
            <p>배송 기간</p>
            <span>
              상품 출고 후 영업일 기준 1~3일 이내 수령이 가능하며 도서 산간
              지역이거나 택배사의 물량이 많은 경우 조금 더 소요될 수 있습니다.
            </span>
          </li>
        </ul>
      </article>
    </section>
  );
};
